var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.676 21.631l14.28-14.873a1.5 1.5 0 0 1 2.164 2.078l-15.362 16a1.5 1.5 0 0 1-2.164 0l-6.638-6.914a1.5 1.5 0 0 1 2.164-2.078l5.556 5.787z"}));
}

Tick.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Tick;

Tick.default = Tick;
